import styled from '@emotion/styled'
import { theme } from '@hhgtech/hhg-components/misc'

export const StyledExploreCategory = styled.div`
  .line {
    width: 100%;
    border: none;
    border-top: 1px dashed ${theme?.colors.neutral100};
    &:last-child() {
      display: none;
    }
  }
`
